module.exports = {
    text: require("./helper.text"),
    html: require("./helper.html"),
};



// WEBPACK FOOTER //
// src/utils/helpers/index.js